/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Automatic_Save_Restore_Aria_LabelInputs */

const en_automatic_save_restore_aria_label = /** @type {(inputs: Automatic_Save_Restore_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Restore Selected Event Groups`)
};

const fr_automatic_save_restore_aria_label = /** @type {(inputs: Automatic_Save_Restore_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Restaurer les groupes d’événements sélectionnés`)
};

const de_automatic_save_restore_aria_label = /** @type {(inputs: Automatic_Save_Restore_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ausgewählte Ereignisgruppen wiederherstellen`)
};

const it_automatic_save_restore_aria_label = /** @type {(inputs: Automatic_Save_Restore_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ripristina gruppi di eventi selezionati`)
};

const ru_automatic_save_restore_aria_label = /** @type {(inputs: Automatic_Save_Restore_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Восстановить выбранные группы событий`)
};

const es_automatic_save_restore_aria_label = /** @type {(inputs: Automatic_Save_Restore_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Restaurar grupos de eventos seleccionados`)
};

const zh_cn2_automatic_save_restore_aria_label = /** @type {(inputs: Automatic_Save_Restore_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`恢复选定的事件组`)
};

const ja_automatic_save_restore_aria_label = /** @type {(inputs: Automatic_Save_Restore_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`選択したイベントグループを復元`)
};

const hi_automatic_save_restore_aria_label = /** @type {(inputs: Automatic_Save_Restore_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`चयनित इवेंट समूहों को पुनर्स्थापित करें`)
};

const pt_pt2_automatic_save_restore_aria_label = /** @type {(inputs: Automatic_Save_Restore_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Restaurar grupos de eventos selecionados`)
};

/**
* | output |
* | --- |
* | "Restore Selected Event Groups" |
*
* @param {Automatic_Save_Restore_Aria_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const automatic_save_restore_aria_label = /** @type {((inputs?: Automatic_Save_Restore_Aria_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Automatic_Save_Restore_Aria_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_automatic_save_restore_aria_label(inputs)
	if (locale === "de") return de_automatic_save_restore_aria_label(inputs)
	if (locale === "it") return it_automatic_save_restore_aria_label(inputs)
	if (locale === "ru") return ru_automatic_save_restore_aria_label(inputs)
	if (locale === "es") return es_automatic_save_restore_aria_label(inputs)
	if (locale === "zh-CN") return zh_cn2_automatic_save_restore_aria_label(inputs)
	if (locale === "ja") return ja_automatic_save_restore_aria_label(inputs)
	if (locale === "hi") return hi_automatic_save_restore_aria_label(inputs)
	if (locale === "pt-PT") return pt_pt2_automatic_save_restore_aria_label(inputs)
	return en_automatic_save_restore_aria_label(inputs)
});